export default function Python_While_Loops() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Python_While_Loops</h1>
      <p>Content for Python_While_Loops goes here.</p>
    </div>
  );
}